<template>
  <div class="content-page">
    <div class="bd">
      <div class="tab-header">
        <div class="header-left">
          <el-button type="primary" size="small" @click="addBooking('add')"
            >添加预约</el-button
          >
        </div>
        <div class="header-right">
          <div>
            <span>日期：</span>
            <el-date-picker
              v-model="selDate"
              type="date"
              placeholder="选择日期"
              size="small"
              clearable
            >
            </el-date-picker>
          </div>
          <div>
            <span>时间间隔：</span>
            <el-radio-group v-model="timeStep">
              <el-radio :label="15">15分钟</el-radio>
              <el-radio :label="30">30分钟</el-radio>
              <el-radio :label="60">1小时</el-radio>
              <el-radio :label="120">2小时</el-radio>
            </el-radio-group>
          </div>
          <div>
            <span>预约颜色状态：</span>
            <el-radio-group v-model="colorSel">
              <el-radio label="dark"
                >深色
                <div class="legend-icon dark legend-icon-booked"></div>
                <div class="legend-icon dark legend-icon-serving"></div>
                <div class="legend-icon dark legend-icon-unassign"></div>
                <div class="legend-icon dark legend-icon-idle"></div>
              </el-radio>
              <el-radio label="thin"
                >浅色
                <div class="legend-icon thin legend-icon-booked"></div>
                <div class="legend-icon thin legend-icon-serving"></div>
                <div class="legend-icon thin legend-icon-unassign"></div>
                <div class="legend-icon thin legend-icon-idle"></div
              ></el-radio>
            </el-radio-group>
          </div>
        </div>
      </div>
      <div class="tab-content">
        <div class="gantt-myyy">
          <div class="gantt-myyy-container grayFlay">
            <div
              class="gantt-myyy-time-line"
              :style="{
                top: `${tableHeaderH}px`,
                height: `calc(100% - ${tableHeaderH}px)`,
                width: `${tableHeaderW}px`,
              }"
            >
              <div
                class="left-scroll-container"
                :style="{
                  top: `${contentScrollTop * -1}px`,
                  height: `${timeList.length * cellHeight}px`,
                }"
              >
                <div
                  class="left-header-cell time"
                  :style="{ height: `${cellHeight}px` }"
                  v-for="(item, index) in timeList"
                  :key="item"
                >
                  <div class="main-text time-text">
                    <div v-if="index % 2 == 0">
                      <strong>{{ item }}</strong>
                    </div>
                    <div v-else>{{ item }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="gantt-myyy-header"
              :style="{
                height: `${tableHeaderH}px`,
                marginLeft: `${tableHeaderW}px`,
                width: `calc(100% - ${tableHeaderW * 2}px)`,
              }"
            >
              <div class="dynamic-block" ref="topScrollConWrap">
                <div
                  class="top-scroll-container"
                  :style="{ left: `${contentScrollLeft * -1}px` }"
                  ref="topScrollCon"
                >
                  <div
                    class="header-cell top-header"
                    :style="{
                      height: `${tableHeaderH}px`,
                      width: `${cellWidth}px`,
                    }"
                    v-for="item in artisansList"
                    :key="item.workUserName"
                  >
                    <span class="header-content">{{ item.workUserName }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="grid-content"
              :style="{ width: `calc(100% - ${tableHeaderW * 2}px)` }"
            >
              <div
                class="gantt-myyy-main grid-content-for-scroll"
                :style="{ height: `calc(100% - ${tableHeaderH}px)` }"
                ref="contentScroll"
                @scroll="onContentScroll"
              >
                <div class="content-container">
                  <div class="emptyCellList">
                    <div
                      class="content-row"
                      v-for="item in timeList"
                      :key="item"
                    >
                      <div
                        class="content-cell"
                        v-for="(subitem, index) in artisansList"
                        :key="item + index"
                      >
                        <div class="gantt-myyy-cell">
                          <div
                            class="cell"
                            :class="{
                              notAvailable: !isAvailable(item),
                              available: isAvailable(item),
                            }"
                            :style="{
                              width: `${cellWidth}px`,
                              height: `${cellHeight}px`,
                            }"
                          >
                            <div
                              class="reserve-content"
                              v-if="isAvailable(item)"
                            >
                              <span
                                class="add-reserve-note"
                                :style="{
                                  'line-height': `${cellHeight / 2 - 1}px`,
                                  height: `${cellHeight / 2 - 1}px`,
                                }"
                                @click="addBooking('add', subitem, item)"
                                >新增预约</span
                              ><span
                                class="add-reserve-note add-occupy"
                                :style="{
                                  'line-height': `${cellHeight / 2 - 1}px`,
                                  height: `${cellHeight / 2 - 1}px`,
                                }"
                                @click="addBooking('occupy', subitem, item)"
                                >添加占用</span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="reserveList rest">
                    <div
                      class="reserveItem rest"
                      :style="{
                        left: `${(cellWidth / item.sameNum) * item.leftIndex +
                          item.colIndex * cellWidth}px`,
                        top: `${(item.top / (timeStep * 60 * 1000)) *
                          cellHeight}px`,
                        height: `${(item.height / (timeStep * 60 * 1000)) *
                          cellHeight}px`,
                        width: `${cellWidth / item.sameNum}px`,
                      }"
                      v-for="(item, sindex) in bookingBoardList.rest"
                      :key="sindex"
                    ></div>
                  </div>
                  <div class="reserveList occupy">
                    <div
                      :class="`reserveItem ${colorSel} occupy`"
                      :style="{
                        left: `${(cellWidth / item.sameNum) * item.leftIndex +
                          1 +
                          item.colIndex * cellWidth}px`,
                        top: `${(item.top / (timeStep * 60 * 1000)) *
                          cellHeight}px`,
                        height: `${(item.height / (timeStep * 60 * 1000)) *
                          cellHeight}px`,
                        width: `${cellWidth / item.sameNum}px`,
                      }"
                      v-for="(item, sindex) in bookingBoardList.occupy"
                      :key="sindex"
                    >
                      已占用
                      <div class="reservePop" style="left: 100%;">
                        <section class="booking-details">
                          <div class="opacity"></div>
                          <div class="main">
                            <div class="pop-container">
                              <div class="occupy-content">
                                <span>占用时间</span>
                                <span
                                  >{{
                                    new Date(item.startTimeStr).pattern("MM/dd")
                                  }}
                                  {{
                                    new Date(item.startTimeStr).pattern(
                                      "HH:mm"
                                    )
                                  }}-{{
                                    new Date(item.endTimeStr).pattern("HH:mm")
                                  }}</span
                                >
                              </div>
                              <div class="occupy-content row2">
                                <span
                                  >占用时长：{{
                                    (item.endTime - item.startTime) / 1000 / 60
                                  }}分钟</span
                                >
                                <span>手艺人： {{ item.nickName }}</span>
                              </div>
                              <div class="occupy-content row2">
                                <p class="remark">
                                  备注：{{ item.shoperRemark }}
                                </p>
                              </div>
                              <div class="footer">
                                <el-button
                                  type="primary"
                                  plain
                                  size="small"
                                  @click="cancelOccupy(item)"
                                  >取消占用</el-button
                                >
                              </div>
                            </div>
                          </div>
                        </section>
                      </div>
                    </div>
                  </div>
                  <div class="reserveList reserve">
                    <div
                      :class="`reserveItem ${colorSel} clickEvent moreOneCell`"
                      :style="{
                        left: `${(cellWidth / item.sameNum) * item.leftIndex +
                          1 +
                          item.colIndex * cellWidth}px`,
                        top: `${(item.top / (timeStep * 60 * 1000)) *
                          cellHeight}px`,
                        height: `${(item.height / (timeStep * 60 * 1000)) *
                          cellHeight}px`,
                        width: `${cellWidth / item.sameNum}px`,
                      }"
                      v-for="(item, sindex) in bookingBoardList.reserve"
                      :key="sindex"
                    >
                      <div
                        class="dragBox"
                        :class="{
                          booked: item.status == 10,
                          serving: item.status == 20 || item.status == 5,
                          unassign: item.status == 30,
                        }"
                        @click="
                          appointmentOrderInfo(
                            item.appointmentOrderId,
                            item.status == 30 ? 'detail' : 'edit'
                          )
                        "
                      >
                        <div class="clickEvent reserve-guest-name">
                          {{ item.customer.peopleName }}
                        </div>
                        <div class="clickEvent reserve-guest-mobile">
                          <div class="mobile-guest">
                            <span>{{ item.customer.phoneNum }}</span>
                          </div>
                        </div>
                        <div
                          class="tag-serving reserve-online-reserve"
                          v-if="item.haveBill == 1 && item.orderStatus == 10"
                        >
                          已开单
                        </div>
                        <div class="clickEvent reserve-service-item">
                          {{ item.goodName || "未选择服务" }}
                        </div>
                      </div>
                      <div class="reservePop" style="left: 100%;">
                        <section class="booking-details">
                          <div class="opacity"></div>
                          <div class="main">
                            <div class="header">
                              <div class="info">
                                <div class="guest-title">
                                  <div class="guest-name">
                                    {{ item.customer.peopleName }}
                                  </div>
                                  <!-- <div class="new-guest-tag">新客</div> -->
                                </div>
                                <div class="guestMobile">
                                  <div class="mobile">
                                    <div class="mobile-guest">
                                      <span>{{ item.customer.phoneNum }}</span>
                                    </div>
                                  </div>
                                  <!-- <a
                                    class="details"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    ><p class="vip-detail">
                                      会员详情<i
                                        class="zenticon zenticon-right vip-detail-icon"
                                      ></i></p
                                  ></a> -->
                                </div>
                              </div>
                            </div>
                            <div class="pop-container">
                              <div class="serve-items">
                                <div class="server-name">
                                  {{ item.goodName || "未选择服务" }}
                                </div>
                                <div class="server-sku">
                                  {{ item.specDesc }}
                                </div>
                                <div class="server-resourceName">
                                  手艺人：{{
                                    artisansList[item.colIndex].workUserId != -1
                                      ? artisansList[item.colIndex].workUserName
                                      : "未分配"
                                  }}
                                  <p
                                    class="appoint-guest"
                                    v-if="
                                      artisansList[item.colIndex].workUserId !=
                                        -1
                                    "
                                  >
                                    点
                                  </p>
                                </div>
                              </div>
                              <div class="serve-items remark">
                                <p class="remark-title">
                                商家备注：
                                </p>
                                <p class="remark">
                                  {{ item.shoperRemark }}
                                </p>
                              </div>
                            </div>
                            <div class="footer">
                              <el-button
                                size="small"
                                v-if="item.status == 10"
                                @click="confirmArrival(item)"
                              >
                                确认到店</el-button
                              >
                              <el-button
                                type="primary"
                                size="small"
                                v-if="item.haveBill == 0"
                                @click="openOrder(item)"
                              >
                                开单
                              </el-button>
                              <el-button
                                type="primary"
                                size="small"
                                v-if="
                                  item.haveBill == 1 && item.orderStatus == 10
                                "
                                @click="openOrder(item)"
                              >
                                收款
                              </el-button>
                              <el-button
                                type="primary"
                                size="small"
                                v-if="item.status == 30"
                                @click="
                                  appointmentOrderInfo(
                                    item.appointmentOrderId,
                                    'detail'
                                  )
                                "
                              >
                                订单详情
                              </el-button>
                            </div>
                          </div>
                          <div class="opacity"></div>
                        </section>
                      </div>
                    </div>
                  </div>
                  <div
                    class="recentTimeWrap"
                    :style="{
                      top: `${lineStep * cellHeight}px`,
                      left: `${contentScrollLeft}px`,
                    }"
                  >
                    <div class="recentTimeLine"></div>
                    <div class="dont"></div>
                  </div>
                </div>
              </div>
            </div>
            <div
              id="right-header-bar"
              class="gantt-myyy-main-right"
              style="top: 56px; height: calc(100% - 56px); width: 64px;"
              v-if="
                currentDate.pattern('yyyy-MM-dd') ==
                  new Date().pattern('yyyy-MM-dd')
              "
            >
              <div
                class="go-recentTime-btn"
                @click="scrollToTimeLine"
                v-if="
                  contentScrollTop < lineStep * cellHeight - contentScrollCH ||
                    contentScrollTop > lineStep * cellHeight
                "
              >
                最近时间
              </div>
              <div
                class="right-scroll-container"
                :style="{
                  top: `${contentScrollTop * -1}px`,
                }"
              >
                <div
                  class="recentTimeDetail"
                  :style="{ top: `${lineStep * cellHeight}px` }"
                >
                  <span class="recentTimeTxt">最近时间</span
                  ><span class="recentTimeTxt">{{ timeList[lineStep] }}</span>
                </div>
              </div>
            </div>
            <div class="scroll-action">
              <div
                class="scrollIcon scroll-left"
                :class="{
                  disabled: scrollLeftDisable,
                }"
                @click="topScrollToLeft"
                style="width: 64px; height: 56px; line-height: 56px;"
              >
                <i class="icon iconfont icon-icon_zuohua"></i>
              </div>
              <div
                class="scrollIcon scroll-right"
                :class="{
                  disabled: scrollRightDisable,
                }"
                @click="topScrollToRight"
                style="width: 64px; height: 56px; line-height: 56px;"
              >
                <i class="icon iconfont icon-icon_youhua"></i>
              </div>
            </div>
          </div>
          <div class="state-info">
            <div class="g-widget">
              <div :class="`legend-icon ${colorSel} legend-icon-booked`"></div>
              <span>待到店</span>
            </div>
            <div class="g-widget">
              <div :class="`legend-icon ${colorSel} legend-icon-serving`"></div>
              <span>已到店</span>
            </div>
            <div class="g-widget">
              <div
                :class="`legend-icon ${colorSel} legend-icon-unassign`"
              ></div>
              <span>已完成</span>
            </div>
            <div class="g-widget">
              <div :class="`legend-icon ${colorSel} legend-icon-idle`"></div>
              <span>空闲</span>
            </div>
            <div class="g-widget">
              <div :class="`legend-icon ${colorSel} legend-icon-rest`"></div>
              <span>休息</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <dialogAddBooking
      ref="dialogaddbooking"
      @getPageData="appointmentOrderData"
    >
    </dialogAddBooking>
  </div>
</template>

<script>
import {
  appointmentOrderData,
  schedulingList,
  updateAppointmentOrderStatus,
  appointmentOrderInfo,
  findArtisansAll,
} from "@/api/index";
import { mapState } from "vuex";
import dialogAddBooking from "@/components/dialogAddBooking";
import { commonFuc } from "@/mixins/commonFuc";

export default {
  mixins: [commonFuc],
  data() {
    return {
      selDate: new Date(),
      currentDate: new Date(),
      timeStep: 15,
      colorSel: "dark",
      contentScrollTop: 0,
      contentScrollLeft: 0,
      tableHeaderH: 56,
      tableHeaderW: 64,
      cellHeight: 124,
      cellWidth: 120,
      artisansList: [],
      contentScrollCH: 0,
      scrollLeftDisable: false,
      scrollRightDisable: false,
      bookingBoardList: {},
      beginTime: "",
      endTime: "",
      mapArtisansList: {},
    };
  },
  components: {
    dialogAddBooking,
  },
  computed: {
    ...mapState({
      shopInfo: (state) => state.shopInfo,
    }),
    timeList() {
      let beginTime = new Date(
        `${this.currentDate.pattern("yyyy-MM-dd")} ${this.beginTime}`
      );
      let endTime = new Date(
        `${this.currentDate.pattern("yyyy-MM-dd")} ${
          this.endTime.split("]").length == 2
            ? this.endTime.split("]")[1]
            : this.endTime
        }`
      );
      if (this.endTime.split("]").length == 2) {
        endTime = +endTime + 24 * 60 * 60 * 1000;
      }
      let timeStep = this.timeStep * 60 * 1000;
      let stepNum = (endTime - beginTime) / timeStep;
      let currentDay = beginTime.getDate();
      let currentMonth = beginTime.getMonth();
      let timeList = [];
      let i = 0;
      while (i < stepNum) {
        let stepTime = new Date(beginTime);
        let isNextDay =
          stepTime.getDate() > currentDay || stepTime.getMonth() > currentMonth;
        timeList.push(
          `${isNextDay ? "[次日] " : ""}${
            stepTime.getHours() < 10
              ? "0" + stepTime.getHours()
              : stepTime.getHours()
          }:${
            stepTime.getMinutes() < 10
              ? "0" + stepTime.getMinutes()
              : stepTime.getMinutes()
          }`
        );
        beginTime = +beginTime + timeStep;
        i++;
      }
      console.log(123, timeList);
      return timeList;
    },
    lineStep() {
      let beginTime = new Date(
        `${new Date().pattern("yyyy-MM-dd")} ${this.beginTime}`
      );
      let lineStep = Math.ceil(
        (+new Date() - +new Date(beginTime)) / 1000 / 60 / this.timeStep
      );
      if (
        this.currentDate.pattern("yyyy-MM-dd") !=
        new Date().pattern("yyyy-MM-dd")
      ) {
        return -1;
      }
      return lineStep;
    },
  },
  watch: {
    timeStep() {
      this.scrollToTimeLine();
    },
    selDate(val) {
      if (val) {
        this.currentDate = val;
      } else {
        this.currentDate = new Date();
      }
      this.appointmentOrderData();
    },
  },
  mounted() {
    this.contentScrollCH = this.$refs.contentScroll.clientHeight;
    this.computedDisabled();
    // this.findArtisansAll();
    this.formatTimeList();
  },
  methods: {
    openOrder(item) {
      this.$router.push(
        `/home/my/order?appointmentOrderId=${item.appointmentOrderId}`
      );
    },
    addBooking(type = "add", json = null, time = "") {
      let addBookingForm = {
        bookingList: [
          {
            serviceInfo: {
              label: "",
              serviceTime: "",
              specDesc: "",
            },
            goodsId: "",
            productId: "",
            workUserId: "",
          },
        ],
        workUserId: json ? json.workUserId : "",
        appointmentDate: this.currentDate,
        hourStep: type == "occupy" ? parseInt(0) : parseInt(1),
        minuteStep: type == "occupy" ? parseInt(5) : parseInt(0),
        startTime: time,
        orderType: json ? json.orderType : 1,
      };
      this.$refs.dialogaddbooking.showAddBooking(type, addBookingForm, time);
    },
    confirmArrival(item) {
      this.updateAppointmentOrderStatus(20, item);
    },
    cancelOccupy(item) {
      this.updateAppointmentOrderStatus(-2, item);
    },
    updateAppointmentOrderStatus(status, item) {
      updateAppointmentOrderStatus({
        status: status,
        appointmentOrderId: item.appointmentOrderId,
      }).then((res) => {
        if (res.code == 1) {
          this.$notify({
            title: "提示",
            message: "操作成功",
            type: "success",
            duration: 2000,
          });
          this.pageNo = 1;
          this.appointmentOrderData();
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "error",
            duration: 2000,
          });
        }
      });
    },
    appointmentOrderInfo(appointmentOrderId, type) {
      appointmentOrderInfo({
        appointmentOrderId: appointmentOrderId,
      }).then((res) => {
        if (res.code == 1) {
          let item = res.data;
          let addBookingForm = {
            appointmentOrderId: item.appointmentOrderId,
            phoneNum: item.phoneNum,
            peopleName: item.peopleName,
            payMoney: item.payMoney,
            bookingList: [
              {
                serviceInfo: {
                  label: item.goodsName,
                  serviceTime: "",
                  specDesc: item.specDesc,
                },
                goodsId: item.goodsId,
                productId: item.productId,
                workUserId: item.workUserId,
              },
            ],
            appointmentDate: item.appointmentDate,
            hourStep: parseInt(
              (item.endTime - item.startTime) / 1000 / 60 / 60
            ),
            minuteStep: parseInt(
              ((item.endTime - item.startTime) / 1000 / 60) % 60
            ),
            startTime: item.startTimePart,
            endTime: item.endTimePart,
            shoperRemark: item.shoperRemark,
            shopMemberId: item.shopMemberId || "",
            cashCouponId: item.cashCouponId || "",
            orderType: item.orderType,
          };
          this.$refs.dialogaddbooking.showAddBooking(type, addBookingForm);
        }
      });
    },
    formatTimeList() {
      let timeInterval = this.timeStep * 60 * 1000;
      schedulingList({ row: 9999 }).then((res) => {
        let timeList = [];
        if (res.code == 1) {
          res.data.forEach((val) => {
            if (val.peopleNum) {
              let startTime = new Date(
                `${new Date().pattern("yyyy-MM-dd")} ${val.startTime}`
              );
              let endTime = val.endTime.split("]");
              if (endTime.length == 2) {
                endTime = new Date(
                  `${new Date(+new Date() + 24 * 60 * 60 * 1000).pattern(
                    "yyyy-MM-dd"
                  )} ${endTime[1].trim()}`
                );
              } else {
                endTime = new Date(
                  `${new Date().pattern("yyyy-MM-dd")} ${endTime[0].trim()}`
                );
              }
              console.log(endTime);
              let currentDay = startTime.getDate();
              let currentMonth = startTime.getMonth();
              while (startTime <= +endTime) {
                let stepTime = new Date(startTime);
                let isNextDay =
                  stepTime.getDate() > currentDay ||
                  stepTime.getMonth() > currentMonth;
                let findIndex = timeList.findIndex(
                  (ival) =>
                    ival.value ==
                    `${isNextDay ? "[次日]" : ""}${stepTime.pattern("HH:mm")}`
                );
                if (findIndex == -1) {
                  timeList.push({
                    value: `${isNextDay ? "[次日]" : ""}${stepTime.pattern(
                      "HH:mm"
                    )}`,
                    label: `${isNextDay ? "[次日]" : ""}${stepTime.pattern(
                      "HH:mm"
                    )}`,
                    peopleNum: val.peopleNum,
                    className: "",
                  });
                } else {
                  if (timeList[findIndex].peopleNum < val.peopleNum) {
                    timeList[findIndex].peopleNum = val.peopleNum;
                  }
                }
                startTime = +startTime + timeInterval;
              }
            }
          });
          console.log("beforesort", timeList);
          timeList.sort((a, b) => {
            let startTime = a.value.split("]");
            if (startTime.length == 2) {
              startTime = new Date(
                `${new Date(+new Date() + 24 * 60 * 60 * 1000).pattern(
                  "yyyy-MM-dd"
                )} ${startTime[1].trim()}`
              );
            } else {
              startTime = new Date(
                `${new Date().pattern("yyyy-MM-dd")} ${startTime[0].trim()}`
              );
            }
            let endTime = b.value.split("]");
            if (endTime.length == 2) {
              endTime = new Date(
                `${new Date(+new Date() + 24 * 60 * 60 * 1000).pattern(
                  "yyyy-MM-dd"
                )} ${endTime[1].trim()}`
              );
            } else {
              endTime = new Date(
                `${new Date().pattern("yyyy-MM-dd")} ${endTime[0].trim()}`
              );
            }
            return +startTime > +endTime ? 1 : -1;
          });
          console.log(timeList);
        }
        this.beginTime = timeList.length ? timeList[0].value : "00:00";
        this.endTime = timeList.length
          ? timeList[timeList.length - 1].value
          : "24:00";
        this.appointmentOrderData();
      });
    },
    isAvailable(time) {
      let timeText = time.split(" ");
      let isCurrentDay = timeText.length == 1;
      let currentDay = +new Date(this.currentDate);
      if (!isCurrentDay) {
        currentDay = currentDay + 24 * 60 * 60 * 1000;
      }
      return (
        +new Date() <=
        new Date(
          `${new Date(currentDay).pattern("yyyy-MM-dd")} ${
            !isCurrentDay ? timeText[1] : timeText[0]
          }`
        )
      );
    },
    findArtisansAll() {
      findArtisansAll().then((res) => {
        if (res.code == 1) {
          res.data.forEach((val) => {
            this.mapArtisansList[val.workUserId] = val;
          });
        }
      });
    },
    appointmentOrderData() {
      appointmentOrderData({
        appointmentDate: this.currentDate.pattern("yyyy-MM-dd"),
      }).then((res) => {
        console.log(res);
        this.artisansList = [];
        if (res.code == 1) {
          let orderDataList = res.data;
          let bookingBoardList = {};
          let beginTime = new Date(
            `${this.currentDate.pattern("yyyy-MM-dd")} ${this.beginTime}`
          );
          orderDataList.forEach((val, index) => {
            if (!bookingBoardList["rest"]) {
              bookingBoardList["rest"] = [];
            }
            if (val) {
              console.log(
                !this.isLess(val.startTime, this.timeList[0], this.currentDate),
                val.startTime,
                this.timeList[0],
                this.currentDate
              );
              if (
                !this.isLess(val.startTime, this.timeList[0], this.currentDate)
              ) {
                let startTime = this.formatTime(
                  this.timeList[0],
                  this.currentDate
                );
                bookingBoardList["rest"].push({
                  colIndex: index,
                  endTime: val.startTime,
                  endTimeStr: new Date(Number(val.startTime)).pattern(
                    "yyyy-MM-dd HH:mm:ss"
                  ),
                  height: Number(val.startTime) - Number(+startTime),
                  leftIndex: 0,
                  sameNum: 1,
                  sameSplit: 1,
                  startTime: +startTime,
                  startTimeStr: startTime.pattern("yyyy-MM-dd HH:mm:ss"),
                  top: Number(+startTime) - +beginTime,
                });
              }
              console.log(
                this.isLess(
                  val.endTime,
                  this.timeList[this.timeList.length - 1],
                  this.currentDate
                ),
                val.endTime,
                this.timeList[0],
                this.timeList[this.timeList.length - 1],

                this.currentDate,
                bookingBoardList["rest"]
              );
              if (
                this.isLess(
                  val.endTime,
                  this.timeList[this.timeList.length - 1],
                  this.currentDate
                )
              ) {
                let endTime = this.formatTime(this.endTime, this.currentDate);
                console.log(endTime, val.endTime);
                bookingBoardList["rest"].push({
                  colIndex: index,
                  endTime: +endTime,
                  endTimeStr: new Date(Number(+endTime)).pattern(
                    "yyyy-MM-dd HH:mm:ss"
                  ),
                  height: Number(val.endTime) - Number(+endTime),
                  leftIndex: 0,
                  sameNum: 1,
                  sameSplit: 1,
                  startTime: val.endTime,
                  startTimeStr: new Date(Number(val.endTime)).pattern(
                    "yyyy-MM-dd HH:mm:ss"
                  ),
                  top: Number(val.endTime) - +beginTime,
                });
              }
            }
            this.artisansList.push({
              workUserName: val.nickName,
              workUserId: val.workUserId,
            });
            val.appointmentList.forEach((listVal) => {
              listVal.sameSplit = 0;
              listVal.workUserId = val.workUserId;
              res.data[index].appointmentList.forEach((sval) => {
                if (
                  Number(sval.startTime) <= Number(listVal.startTime) &&
                  Number(sval.endTime) >= Number(listVal.startTime)
                ) {
                  listVal.sameSplit++;
                  if (listVal.sameSplit >= 2) {
                    if (!sval.splitIndex) {
                      sval.splitIndex = sval.startTime;
                      listVal.splitIndex = sval.splitIndex;
                    } else {
                      listVal.splitIndex = sval.splitIndex;
                    }
                  }
                }
              });
            });
          });
          orderDataList.forEach((val, index) => {
            val.appointmentList.reverse();
            val.appointmentList.forEach((sval) => {
              sval.colIndex = index;
              if (sval.status == 20 || sval.status == 10 || sval.status == 30) {
                if (!bookingBoardList["reserve"]) {
                  bookingBoardList["reserve"] = [];
                }
                let sameNum = bookingBoardList["reserve"].filter((fval) => {
                  return (
                    fval.splitIndex &&
                    sval.splitIndex == fval.splitIndex &&
                    sval.workUserId == fval.workUserId
                  );
                });
                sval.leftIndex = sameNum.length;
                bookingBoardList["reserve"].push(sval);
              } else if (sval.status == 2) {
                if (!bookingBoardList["occupy"]) {
                  bookingBoardList["occupy"] = [];
                }
                let sameNum = bookingBoardList["occupy"].filter((fval) => {
                  return (
                    fval.splitIndex &&
                    sval.splitIndex == fval.splitIndex &&
                    sval.workUserId == fval.workUserId
                  );
                });
                sval.leftIndex = sameNum.length;
                sval.nickName = val.nickName;
                bookingBoardList["occupy"].push(sval);
              }
            });
          });
          console.log(beginTime);
          Object.keys(bookingBoardList).forEach((key) => {
            bookingBoardList[key].forEach((val) => {
              let sameNum = bookingBoardList[key].filter((fval) => {
                return (
                  fval.splitIndex &&
                  val.splitIndex == fval.splitIndex &&
                  val.workUserId == fval.workUserId
                );
              });
              val.sameNum = sameNum.length || 1;
              val.top = Number(val.startTime) - +beginTime;
              val.height = Number(val.endTime) - Number(val.startTime);
            });
          });

          console.log(orderDataList, bookingBoardList);
          this.bookingBoardList = bookingBoardList;
        }
        setTimeout(() => {
          this.scrollToTimeLine();
        }, 500);
      });
    },
    onContentScroll(e) {
      let event = e.target;
      this.contentScrollTop = event.scrollTop;
      this.contentScrollLeft = event.scrollLeft;
      this.computedDisabled();
    },
    scrollToTimeLine() {
      this.$refs.contentScroll.scrollTop =
        this.lineStep * this.cellHeight - 100;
    },
    computedDisabled() {
      if (this.$refs.topScrollConWrap) {
        if (this.$refs.contentScroll.scrollLeft != 0) {
          this.scrollLeftDisable = false;
        } else {
          this.scrollLeftDisable = true;
        }
      }
      if (this.$refs.topScrollConWrap) {
        if (
          this.$refs.contentScroll.scrollLeft <
          this.$refs.topScrollCon.scrollWidth -
            this.$refs.topScrollConWrap.clientWidth
        ) {
          this.scrollRightDisable = false;
        } else {
          this.scrollRightDisable = true;
        }
      }
    },
    topScrollToLeft() {
      this.$refs.contentScroll.scrollLeft =
        this.$refs.contentScroll.scrollLeft - this.cellWidth;
    },
    topScrollToRight() {
      this.$refs.contentScroll.scrollLeft =
        this.$refs.contentScroll.scrollLeft + this.cellWidth;
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  .bd {
    height: 100%;
    overflow: hidden;
  }
  .header-right {
    & > div {
      margin-left: 20px;
      display: flex;
      align-items: center;
      & > span {
        margin-right: 5px;
        margin-top: -4px;
      }
    }
  }
  .tab-content {
    .gantt-myyy {
      width: 100%;
      position: relative;
      .gantt-myyy-container {
        border-top: 1px solid #ebedf0;
        height: 74vh;
        position: relative;
        &.grayFlay {
          height: 81vh;
        }
        ::-webkit-scrollbar-track {
          box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.3);
          -webkit-box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.3);
          border-radius: 10px;
          background-color: #ffffff;
        }
        ::-webkit-scrollbar {
          display: block;
          width: 10px;
          height: 10px;
          background-color: #f5f5f5;
        }
        ::-webkit-scrollbar-thumb {
          border-radius: 10px;
          box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.3);
          -webkit-box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.3);
          background-color: #eeeeee;
        }
        .grid-content {
          display: inline-block;
          vertical-align: top;
          height: 100%;
          margin-left: 64px;
          .gantt-myyy-main {
            vertical-align: top;
            overflow: auto;
            width: 100%;
            scroll-behavior: smooth;
            .gantt-myyy-cell {
              cursor: pointer;
              .cell {
                display: flex;
                align-items: center;
                justify-content: center;
                box-sizing: border-box;
                border-right: 1px solid #ebedf0;
                border-bottom: 1px solid #ebedf0;
              }
              .available {
                background: #fff;
                cursor: pointer;
                &:hover {
                  .add-reserve-note {
                    visibility: visible;
                  }
                }
              }
              .reserve-content {
                display: flex;
                flex-direction: column;
                width: 100%;
                height: 100%;
              }
              .notAvailable {
                background: #f2f3f5;
                cursor: not-allowed;
              }
              .add-reserve-note {
                color: #8558fa;
                font-size: 12px;
                visibility: hidden;
                width: 100%;
                display: inline-block;
                text-align: center;
                background: #f6f4ff;
              }
              .add-reserve-note:active {
                color: #4d1ccc;
              }
              .add-occupy {
                background: #fff;
                border-top: 1px solid #ebedf0;
              }
            }
            .content-container {
              display: flex;
              flex-direction: column;
              position: relative;
            }
            .content-row {
              display: flex;
            }
            .content-cell {
              flex-shrink: 0;
              font-size: 12px;
              align-self: center;
              display: flex;
              justify-content: center;
              box-sizing: border-box;
              flex-direction: column;
              background-color: #fff;
            }
            .reserveItem {
              position: absolute;
              width: 85px;
              font-size: 12px !important;
              box-sizing: border-box;
              cursor: pointer;
              line-height: 12px !important;
              text-align: left;
              border-bottom: 1px solid #ebedf0;
              display: flex;
              flex-direction: column;
              border-radius: 2px;
              .dragBox {
                padding: 10px;
                height: 100%;
              }
              .reserve-count {
                text-align: center;
                width: 20px;
                height: 20px;
                line-height: 20px;
                border-radius: 50%;
                color: #fff;
                margin: 0 auto;
              }
              .reserve-guest-name {
                font-weight: 500;
                flex-shrink: 0;
                overflow: hidden;
              }
              .reserve-guest-mobile {
                font-weight: 400;
                margin-top: 6px;
                line-height: 12px;
                overflow: hidden;
                flex-shrink: 0;
              }
              .reserve-service-item {
                font-weight: 400;
                margin-top: 6px;
                line-height: 14px;
                overflow: hidden;
                flex-shrink: 1;
              }
              .reserve-online-reserve {
                position: absolute;
                top: 0;
                right: 0;
                height: 16px;
                background: #fff;
                border-radius: 0px 2px 0px 2px;
                font-size: 12px;
                font-weight: 500;
                line-height: 16px;
                text-align: center;
                padding-left: 3px;
                padding-right: 3px;
              }
              .tag-serving {
                border: 1px solid #8558fa;
                color: #8558fa;
              }
              .tag-unassign {
                border: 1px solid #2cbcbb;
                color: #2cbcbb;
              }
              .tag-booked {
                border: 1px solid #fd678b;
                color: #fd678b;
              }
              .reserve-guest-name,
              .reserve-count {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              &:hover {
                .reservePop {
                  visibility: visible;
                }
              }
              & .booked {
                color: #fff;
                background: #fd678b;
                .reserve-count {
                  background: #ff2278;
                }
              }
              &.dark .booked {
                color: #fff;
                background: #7568e5;
                .reserve-count {
                  background: #7568e5;
                }
              }
              &.thin .booked {
                color: #51489f;
                background: #e6e3ff;
                .reserve-count {
                  background: #e6e3ff;
                }
              }
              & .serving {
                color: #fff;
                background: #8558fa;
                .reserve-count {
                  background: var(--c_main, #8558fa);
                }
              }
              &.dark .serving {
                color: #fff;
                background: #f07882;
                .reserve-count {
                  background: #f07882;
                }
              }
              &.thin .serving {
                color: #a7535a;
                background: #fce4e6;
                .reserve-count {
                  background: #fce4e6;
                }
              }
              & .unassign {
                color: #fff;
                background: #2cbcbb;
                .reserve-count {
                  background: #2da641;
                }
              }
              &.dark .unassign {
                color: #fff;
                background: #60beca;
                .reserve-count {
                  background: #60beca;
                }
              }
              &.thin .unassign {
                color: #43848d;
                background: #dff2f4;
                .reserve-count {
                  background: #dff2f4;
                }
              }
              &.rest {
                color: #c8c9cc;
                cursor: not-allowed;
                background: repeating-linear-gradient(
                  30deg,
                  #ebedf0,
                  #ebedf0 1px,
                  #fff 0,
                  #fff 16px
                );
                background-repeat: repeat-y;
                border: 1px solid #ebedf0;
              }
              &.dark.occupy {
                padding: 10px;
                text-align: center;
                color: #fff;
                background: #f0b759;
                cursor: pointer;
              }
              &.thin.occupy {
                padding: 10px;
                text-align: center;
                color: #b38942;
                background: #fcf1de;
                cursor: pointer;
              }
              &:not(.rest) {
                border-right: 1px solid #ebedf0;
              }
            }
            .occupy {
              .reservePop {
                .booking-details {
                  .main {
                    min-height: auto;
                    .pop-container {
                      padding: 0 10px;
                      .occupy-content {
                        width: 100%;
                        display: flex;
                        justify-content: space-between;
                        color: #f7b500;
                        font-size: 18px;
                        line-height: 30px;
                        &.row2 {
                          font-size: 14px;
                          color: #969799;
                          p {
                            text-align: left;
                          }
                        }
                      }
                      .footer {
                        width: 100%;
                        text-align: right;
                        margin-top: 20px;
                        box-sizing: border-box;
                        padding: 10px 0;
                      }
                    }
                  }
                }
              }
            }
            .reservePop {
              visibility: hidden;
              position: absolute;
              top: 0;
              left: 100%;
              z-index: 999;
              .booking-details {
                width: 330px;
                display: flex;
                cursor: default;
                .opacity {
                  width: 10px;
                  opacity: 0;
                }
                .main {
                  min-height: 260px;
                  background-color: #fff;
                  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.08);
                  width: 320px;
                  border-radius: 2px;
                  display: flex;
                  flex-direction: column;
                  .header {
                    padding: 20px 24px 16px 24px;
                    display: flex;
                    border-bottom: 1px solid #f2f2f2;
                    .img {
                      width: 38px;
                      height: 38px;
                      margin-right: 15px;
                      background: #dcdee0;
                      border: 1px solid #dcdee0;
                      border-radius: 19px;
                      img {
                        width: 38px;
                        height: 38px;
                        border-radius: 19px;
                      }
                    }
                    .info {
                      width: 100%;
                      .guest-title {
                        display: flex;
                        flex-direction: row;
                        margin-bottom: 12px;
                        width: 210px;
                        .guest-name {
                          font-size: 16px;
                          font-family: PingFangSC-Medium, PingFang SC;
                          font-weight: 500;
                          color: #323233;
                          line-height: 20px;
                          overflow: hidden;
                          white-space: nowrap;
                          text-overflow: ellipsis;
                        }
                        .new-guest-tag {
                          flex-shrink: 0;
                          margin-left: 6px;
                          width: 32px;
                          height: 16px;
                          border-radius: 2px;
                          border: 1px solid #fd678b;
                          font-size: 12px;
                          font-family: PingFangSC-Regular, PingFang SC;
                          font-weight: 400;
                          color: #fd678b;
                          line-height: 16px;
                          text-align: center;
                        }
                        .net-reserve-tag {
                          flex-shrink: 0;
                          margin-left: 6px;
                          width: 56px;
                          height: 16px;
                          border-radius: 2px;
                          border: 1px solid #2eab76;
                          font-size: 12px;
                          font-family: PingFangSC-Regular, PingFang SC;
                          font-weight: 400;
                          color: #2eab76;
                          line-height: 16px;
                          text-align: center;
                        }
                      }
                      .guestMobile {
                        display: flex;
                        justify-content: space-between;
                        .mobile {
                          font-size: 14px;
                          font-family: PingFangSC-Regular, PingFang SC;
                          font-weight: 400;
                          color: #6d6e70;
                          line-height: 12px;
                        }
                        .details {
                          font-size: 14px;
                          font-family: PingFangSC-Regular, PingFang SC;
                          font-weight: 400;
                          line-height: 12px;
                        }
                        .vip-detail-icon {
                          margin-left: 6px;
                          font-size: 12px;
                        }
                      }
                    }
                  }
                  .real-guest-name {
                    display: flex;
                    font-size: 14px;
                    margin-top: 12px;
                    align-self: flex-start;
                    margin-left: 24px;
                    .real-guest-title,
                    .real-guest-val {
                      font-family: PingFangSC-Regular, PingFang SC;
                      font-weight: 400;
                      color: #323233;
                      line-height: 20px;
                      flex-shrink: 0;
                      max-width: 195px;
                      overflow: hidden;
                      flex-wrap: nowrap;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                    }
                    .real-guest-title {
                      flex-shrink: 0;
                      &::before {
                        content: "";
                        width: 6px;
                        height: 6px;
                        background-color: #ff2278;
                        border-radius: 3px;
                        line-height: 14px;
                        display: inline-block;
                        margin-right: 4px;
                        vertical-align: middle;
                      }
                    }
                  }
                  .pop-container {
                    display: flex;
                    flex-direction: column;
                    // max-height: 210px;
                    overflow-y: auto;
                    margin-top: 16px;
                    margin-bottom: 8px;
                    align-items: center;
                    .serve-items {
                      background: #f2f2f2;
                      margin-bottom: 16px;
                      padding: 12px;
                      width: 248px;
                      word-break: break-all;
                      &.remark {
                          font-size: 14px;
                        background: #fff;
                        padding: 0 12px;
                        .remark-title {
                          margin-bottom: 10px
                        }
                        .remark {
                          color: #aaa;
                        }
                      }
                      .server-name,
                      .online-pay {
                        font-size: 14px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #323233;
                        line-height: 20px;
                      }
                      .online-pay {
                        display: flex;
                        .pay-count {
                          color: #f44;
                        }
                      }
                      .server-sku {
                        font-size: 14px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #969799;
                        line-height: 20px;
                      }
                      .server-resourceName {
                        font-size: 14px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #6d6e70;
                        line-height: 20px;
                        margin-top: 6px;
                        .appoint-guest {
                          display: inline-block;
                          width: 16px;
                          height: 16px;
                          background: #fff;
                          border-radius: 2px;
                          border: 1px solid #dcdee0;
                          font-size: 10px;
                          font-family: PingFangSC-Regular, PingFang SC;
                          font-weight: 400;
                          color: #646566;
                          line-height: 16px;
                          text-align: center;
                          margin-left: 4px;
                        }
                      }
                    }
                  }
                  .seller-remark,
                  .buyer-memo {
                    width: 272px;
                    padding: 0 24px;
                  }
                  .remark-title,
                  .buyer-title {
                    font-size: 14px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #323233;
                    line-height: 20px;
                  }
                  .remark-container,
                  .buyer-container {
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #6d6e70;
                    line-height: 20px;
                    margin-top: 10px;
                    margin-bottom: 16px;
                  }
                  .footer {
                    display: flex;
                    justify-content: flex-end;
                    padding: 20px 24px;
                    padding-top: 0;
                  }
                }
              }
            }
            .recentTimeWrap {
              position: absolute;
              width: 100%;
            }
            .recentTimeLine {
              width: 100%;
              height: 2px;
              background: var(--c_main, #8558fa);
            }
            .dont {
              top: -5px;
              width: 10px;
              height: 10px;
              background: var(--c_main, #8558fa);
              border-radius: 50%;
              position: absolute;
              right: 0;
            }
            &.oneEighthCell,
            &.twoEighthCell {
              padding-top: 0;
              padding-bottom: 0;
              .reserve-guest-name,
              .reserve-guest-mobile,
              .reserve-service-item,
              .reserve-online-reserve {
                display: none;
              }
            }
            &.threeEighthCell {
              .reserve-guest-name {
                margin-top: -5px;
              }
              .reserve-guest-mobile,
              .reserve-service-item {
                display: none;
              }
            }
            &.halfCell {
              .reserve-guest-name {
                margin-top: 0;
              }
              .reserve-guest-mobile,
              .reserve-service-item {
                display: none;
              }
              &.fiveEighthCell {
                .reserve-guest-name {
                  margin-top: -5px;
                }
                .reserve-guest-mobile {
                  margin-top: 2px;
                }
                .reserve-service-item {
                  display: none;
                }
              }
              &.sixEighthCell {
                .reserve-guest-name {
                  margin-top: -1px;
                }
                .reserve-guest-mobile {
                  margin-top: 2px;
                }
                .reserve-service-item {
                  display: none;
                }
              }
              &.sevenEighthCell {
                .reserve-guest-name {
                  margin-top: 0;
                }
                .reserve-service-item {
                  display: none;
                }
              }
              &.one-twoEighthCell {
                .reserve-guest-name {
                  margin-top: 2px;
                }
                .reserve-guest-mobile {
                  margin-top: 3px;
                }
                .reserve-service-item {
                  margin-top: 0px;
                }
              }
            }
          }
        }
        .trans {
          background-color: rgba(0, 0, 0, 0);
        }
        .align-left {
          justify-content: flex-start;
        }
        .align-center {
          justify-content: center;
        }
        .align-right {
          justify-content: flex-end;
        }
        .justify-left {
          margin-left: -26px !important;
          z-index: 10;
        }
        .justify-right {
          margin-right: -30px !important;
          z-index: 10;
        }
        .sub-text {
          font-size: 10px;
          color: #999999;
          margin-top: 3px;
          width: 100%;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
        body {
          min-width: 600px !important;
        }
        .recentTimeWrap {
          position: absolute;
          width: 100%;
        }
        .recentTimeLine {
          width: 100%;
          height: 2px;
          background: var(--c_main, #8558fa);
        }
        .dont {
          top: -5px;
          width: 10px;
          height: 10px;
          background: var(--c_main, #8558fa);
          border-radius: 50%;
          position: absolute;
          right: 0;
        }
        .gantt-myyy-time-line {
          position: absolute;
          overflow: hidden;
          .left-header-cell:first-child {
            .time-text {
              margin-top: 1px;
            }
          }
          .left-header-cell {
            flex-shrink: 0;
            align-self: center;
            display: flex;
            font-size: 12px;
            justify-content: center;
            padding: 0 10px;
            box-sizing: border-box;
            flex-direction: column;
            background-color: #fff;
            border: 1px solid #ededed;
            border-bottom: none;
          }
          .left-header-cell:last-child {
            border-bottom: 1px solid #ededed;
          }
          .time {
            border-left: none !important;
            border-bottom: none !important;
            border-top: none !important;
            text-align: right;
            width: 100%;
            justify-content: flex-start !important;
          }
          .time-text {
            margin-top: -10px;
            font-size: 14px;
            line-height: 14px;
          }
          .left-scroll-container {
            position: absolute;
            display: flex;
            top: 0;
            flex-direction: column;
            width: 100%;
          }
        }
        .gantt-myyy-header {
          overflow: hidden;
          border-left: 1px solid #ebedf0;
          border-right: 1px solid #ebedf0;
          border-bottom: 1px solid #ebedf0;
          box-sizing: border-box;
          .top-layer {
            z-index: 666;
          }
          .header-title {
            width: 50px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .dynamic-block {
            position: relative;
          }
          .header-cell {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;
            align-self: center;
            background-color: #fff;
            font-size: 12px;
            padding: 0 10px;
            box-sizing: border-box;
            box-shadow: 0 6px 0 rgba(200, 201, 204, 0.5);
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .header-content {
            max-width: 65px;
            line-height: 14px;
            color: #323232;
            font-weight: 500;
            font-size: 14px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .top-scroll-container {
            position: absolute;
            display: flex;
          }
        }
        .scroll-action {
          .scrollIcon {
            background: #fff;
            position: absolute;
            top: 0px;
            cursor: pointer;
            text-align: center;
            border-top: 0;
            border-bottom: 1px solid #ebedf0;
            box-sizing: border-box;
            &.scroll-right {
              right: 0;
              background: url(../assets/img/booking/icon-scroll-right.png);
              background-size: 24px 24px;
              background-repeat: no-repeat;
              background-position: center;
              border-left: 1px solid #ebedf0;
              &:not(.disabled):hover {
                background: url(../assets/img/booking/icon-scroll-right-hover.png);
                background-size: 24px 24px;
                background-position: center;
                background-repeat: no-repeat;
                color: var(--c_main, #8558fa);
              }
              &:not(.disabled):active {
                background: url(../assets/img/booking/icon-scroll-right-active.png);
                background-size: 24px 24px;
                background-position: center;
                background-repeat: no-repeat;
              }
            }
            &.scroll-left {
              left: 0;
              background: url(../assets/img/booking/icon-scroll-left.png);
              background-size: 24px 24px;
              background-position: center;
              background-repeat: no-repeat;
              &:not(.disabled):hover {
                background: url(../assets/img/booking/icon-scroll-left-hover.png);
                background-size: 24px 24px;
                background-position: center;
                background-repeat: no-repeat;
                color: var(--c_main, #8558fa);
              }
              &:not(.disabled):active {
                background: url(../assets/img/booking/icon-scroll-left-active.png);
                background-size: 24px 24px;
                background-position: center;
                background-repeat: no-repeat;
              }
            }
            &.disabled {
              cursor: not-allowed;
              &.scroll-right {
                background: url(../assets/img/booking/icon-scroll-right-disabled.png);
                background-size: 24px 24px;
                background-repeat: no-repeat;
                background-position: center;
              }
              &.scroll-left {
                background: url(../assets/img/booking/icon-scroll-left-disabled.png);
                background-size: 24px 24px;
                background-position: center;
                background-repeat: no-repeat;
              }
            }
          }
          .iconfont {
            color: #646566;
            font-size: 20px;
          }
        }
      }
      .gantt-myyy-main-right {
        position: absolute;
        overflow: hidden;
        top: 0;
        right: 0;
        background: #fff;
        border-left: 1px solid #ebedf0;
        padding-left: 12px;
        box-sizing: border-box;
        .right-scroll-container {
          position: absolute;
          width: 100%;
        }
        .recentTimeDetail {
          position: absolute;
          color: var(--c_main, #8558fa);
          font-size: 12px;
          font-weight: 500;
        }
        .recentTimeLine {
          position: absolute;
          width: 90%;
          height: 1px;
          background: var(--c_main, #8558fa);
        }
        .go-recentTime-btn {
          position: absolute;
          z-index: 99;
          width: 40px;
          height: 40px;
          margin-top: 12px;
          text-align: center;
          background: #fff;
          box-shadow: 0px 2px 8px 0px rgba(50, 50, 52, 0.2);
          border-radius: 50%;
          color: var(--c_main, #8558fa);
          font-size: 12px;
          padding: 0px;
          padding: 6px 3px;
          box-sizing: border-box;
          line-height: 134%;
          cursor: pointer;
        }
      }
      .state-info {
        position: absolute;
        bottom: 16px;
        right: 90px;
        background-color: #fff;
        width: 434px;
        height: 48px;
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.08);
        display: flex;
        justify-content: center;
        align-items: center;
        .iconfont {
          font-family: "iconfont" !important;
          font-size: 16px;
          font-style: normal;
        }
        .g-widget {
          display: inline-flex;
          align-items: center;
          margin-right: 16px;
          & > * + * {
            margin-left: 8px;
          }
          span {
            font-size: 14px;
          }
          &:last-child {
            margin-right: 0;
          }
        }
      }
    }
  }
  .legend-icon {
    display: inline-block;
    width: 14px;
    height: 14px;
    vertical-align: top;
  }
  .legend-icon-booked {
    background-color: #fd678b;
    &.dark {
      background-color: #7568e5;
    }
    &.thin {
      background-color: #e6e3ff;
    }
  }
  .legend-icon-serving {
    background-color: #8558fa;
    &.dark {
      background-color: #f07882;
    }
    &.thin {
      background-color: #fce4e6;
    }
  }
  .legend-icon-unassign {
    background-color: #2cbcbb;
    &.dark {
      background-color: #60beca;
    }
    &.thin {
      background-color: #dff2f4;
    }
  }
  .legend-icon-idle {
    border: 1px solid #ebedf0;
    background-color: #fff;
  }
  .legend-icon-rest {
    background: url("../assets/img/booking/rest.png");
    background-size: 100% 100%;
  }
}
</style>
